// import React, { useState, useEffect, useRef } from "react";
// import { Link, useNavigate } from "react-router-dom";

// const Navigation = () => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const navigate = useNavigate();
//   const navRef = useRef(null); // Reference for the navigation container

//   const handleSearch = () => {
//     if (searchTerm.trim()) {
//       navigate(`/search?q=${encodeURIComponent(searchTerm)}`);
//       // Close mobile menu after search
//       setMobileMenuOpen(false);
//     } else {
//       alert("Please enter a search term");
//     }
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter") {
//       handleSearch();
//     }
//   };

//   const toggleMobileMenu = () => {
//     setMobileMenuOpen(!mobileMenuOpen);
//   };


//   // Close mobile menu when clicking on navigation links
//   const handleLinkClick = () => {
//     setMobileMenuOpen(false);
//   };

//   // Close mobile menu when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         navRef.current &&
//         !navRef.current.contains(event.target) &&
//         mobileMenuOpen
//       ) {
//         setMobileMenuOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [mobileMenuOpen]);

//   // Close mobile menu on window resize (when switching to desktop view)
//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth > 768) {
//         setMobileMenuOpen(false);
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   // Prevent body scroll when mobile menu is open
//   useEffect(() => {
//     if (mobileMenuOpen) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "unset";
//     }

//     // Cleanup function to reset overflow when component unmounts
//     return () => {
//       document.body.style.overflow = "unset";
//     };
//   }, [mobileMenuOpen]);

//   return (
//     <nav>
//       <div className="container">
//         <div className="nav-container">
//           <button className="mobile-menu" onClick={toggleMobileMenu}>
//             ☰
//           </button>
//           <ul className={`nav-links ${mobileMenuOpen ? "active" : ""}`}>
//             <li>
//               <Link to="/" onClick={handleLinkClick}>
//                 Home
//               </Link>
//             </li>
//             <li>
//               <Link to="/products" onClick={handleLinkClick}>
//                 Our Products
//               </Link>
//             </li>
//             <li>
//               <Link to="/about" onClick={handleLinkClick}>
//                 About Us
//               </Link>
//             </li>
//             <li>
//               <Link to="/contact" onClick={handleLinkClick}>
//                 Contact Us
//               </Link>
//             </li>
//           </ul>
//           <div className="search-container">
//             <input
//               type="text"
//               className="search-box"
//               placeholder="Search products..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               onKeyPress={handleKeyPress}
//             />
//             <button className="search-btn" onClick={handleSearch}>
//               Search
//             </button>
//           </div>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navigation;


import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

const Navigation = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const navRef = useRef(null); // Reference for the navigation container

  const handleSearch = () => {
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm)}`);
      // Close mobile menu after search
      setMobileMenuOpen(false);
    } else {
      alert("Please enter a search term");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // Close mobile menu when clicking on navigation links
  const handleLinkClick = () => {
    setMobileMenuOpen(false);
  };

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        navRef.current &&
        !navRef.current.contains(event.target) &&
        mobileMenuOpen
      ) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mobileMenuOpen]);

  // Close mobile menu on window resize (when switching to desktop view)
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    // Cleanup function to reset overflow when component unmounts
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [mobileMenuOpen]);

  return (
    <nav ref={navRef}>
      <div className="container">
        <div className="nav-container">
          {/* Mobile Menu Button */}
          <button
            className="mobile-menu"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
            aria-expanded={mobileMenuOpen}
            aria-controls="nav-links">
            {mobileMenuOpen ? "✕" : "☰"}
          </button>

          {/* Navigation Links */}
          <ul
            className={`nav-links ${mobileMenuOpen ? "active" : ""}`}
            id="nav-links"
            role="menu">
            <li role="menuitem">
              <Link to="/" onClick={handleLinkClick}>
                Home
              </Link>
            </li>
            <li role="menuitem">
              <Link to="/products" onClick={handleLinkClick}>
                Our Products
              </Link>
            </li>
            <li role="menuitem">
              <Link to="/about" onClick={handleLinkClick}>
                About Us
              </Link>
            </li>
            <li role="menuitem">
              <Link to="/contact" onClick={handleLinkClick}>
                Contact Us
              </Link>
            </li>
          </ul>

          {/* Search Container */}
          <div className="search-container">
            <input
              type="text"
              className="search-box"
              placeholder="Search products..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyPress={handleKeyPress}
              aria-label="Search products"
            />
            <button
              className="search-btn"
              onClick={handleSearch}
              aria-label="Search">
              Search
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div
          className="mobile-menu-overlay"
          onClick={() => setMobileMenuOpen(false)}
          aria-hidden="true"
        />
      )}
    </nav>
  );
};

export default Navigation;